/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Serialize TeacherKindergarten  Serialize TeacherKindergarten into same format as Teacher and add some info data from TeacherKindergarten.
 */
export interface TeacherKindergarten { 
    id: number;
    userId: number;
    readonly modified: string;
    readonly teacherKindergartenModified: string;
    readonly user: string;
    readonly isActive: string;
    readonly groups: string;
    readonly groupIds: string;
    readonly isPrimary: string;
    firstName: string;
    lastName: string;
}